import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="page-privacy" style={{ padding: '4rem 1.5rem', maxWidth: '900px', margin: '0 auto' }}>

      {/* Header section */}
      <header style={{ marginBottom: '3rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
        <span className="section-tag" style={{ textTransform: 'uppercase', color: 'var(--accent-color)', fontWeight: 700, fontSize: '0.85rem', letterSpacing: '1.5px' }}>
          Compliance & Legal
        </span>
        <h1 style={{ fontFamily: 'var(--font-title)', fontSize: '2.5rem', fontWeight: 900, textTransform: 'uppercase', color: 'var(--text-primary)', marginTop: '0.5rem', marginBottom: '1rem' }}>
          Privacy Policy
        </h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem' }}>
          Effective Date: January 01, 2026 | Saveera Biotech Guidelines
        </p>
      </header>

      {/* Content body */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', textAlign: 'left', lineHeight: '1.7', color: 'var(--text-secondary)' }}>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            1. Information Collection
          </h3>
          <p>
            At Saveera Biotech, we collect personal information that you provide voluntarily through our website forms, strategy session requests, and contact inquiries. This information may include:
          </p>
          <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem', listStyleType: 'square' }}>
            <li>Full Name and Job Title</li>
            <li>Contact details including corporate email address and telephone numbers</li>
            <li>Company profiles, project goals, and digital marketing requirements</li>
            <li>Any additional messages, attachments, or communications you submit to our team</li>
          </ul>
        </section>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            2. How We Use Collected Data
          </h3>
          <p>
            The information we gather is used to understand your enterprise needs and deliver high-performance technology consulting, computer programming services, and digital marketing plans. Specifically:
          </p>
          <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem', listStyleType: 'square' }}>
            <li>To schedule and prepare your custom strategy consultations and roadmaps</li>
            <li>To compile service proposals, contracts, and software specifications</li>
            <li>To send billing, invoices, legal notifications, and corporate updates</li>
            <li>To evaluate project metrics, enhance user experiences, and resolve technical issues</li>
          </ul>
        </section>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            3. Data Sharing & Third-Party Disclosure
          </h3>
          <p>
            Saveera Biotech does not sell, lease, or distribute your corporate data or personal contact information to third-party advertisers. Your information is only shared:
          </p>
          <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem', listStyleType: 'square' }}>
            <li>With trusted technical consultants and systems engineers bound by strict confidentiality covenants</li>
            <li>To comply with regulatory guidelines, official audits, and legal directives in Telangana and Uttar Pradesh jurisdictions</li>
            <li>To protect our intellectual properties, operational safety, and proprietary source codes</li>
          </ul>
        </section>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            4. Information Security Measures
          </h3>
          <p>
            We implement industry-standard administrative, physical, and digital security measures to safeguard your personal data against unauthorized access, loss, or disclosure. These include secure database endpoints, encrypted transfer sockets (HTTPS), and restricted staff credentials.
          </p>
        </section>

        <section style={{ borderTop: '1px solid var(--border-color)', paddingTop: '2rem', marginTop: '1rem' }}>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            Contact Privacy Officers
          </h3>
          <p>
            If you have questions about this policy, data deletion requests, or our information practices, please contact us at:
          </p>
          <p style={{ marginTop: '0.5rem', fontWeight: 700, color: 'var(--text-primary)' }}>
            Email: <a href="mailto:info@saveerabiotech.com" style={{ color: 'var(--accent-color)', textDecoration: 'none' }}>info@saveerabiotech.com</a>
          </p>
        </section>

      </div>

    </div>
  );
}

export default PrivacyPolicy;
